import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {getAntiWebHook, getAntiWebHookLogs} from '../store/AntiWebHook';
import {getAntiSpam, getAntiSpamAdvanced, getAntiSpamLogs} from '../store/AntiSpam';
import {getAntiNuke, getAntiNukeAdvanced, getAntiNukeLogs} from '../store/AntiNuke';
import {getAntiRaid, getAntiRaidAdvanced, getAntiRaidLogs} from '../store/AntiRaid';
import {getMembers} from '../store/Members';
import {getChannels} from '../store/Channels';
import {getOverview, getOverviewInfo} from '../store/Overview';
import {
  getVerification,
  getVerificationAdvanced,
  getVerificationRules,
  getVerificationMessage,
  getVerificationLogs,
} from '../store/Verification';
import {getDetection, getDetectionAdvanced, getDetectionLogs} from '../store/Detection';
import {setServerId} from '../store/CurrentServerId';
import {servers} from '../constants/common';
import {getRoles} from '../store/Roles';
import {getSettings} from '../store/Settings';
import {getMe} from '../store/CurrentUser';
import {getAllLogs} from '../store/Logs';

export const useInitServerDashboard = () => {
  const dispatch = useDispatch();
  const {id} = useParams();
  const [selectedServer, setSelectedServer] = useState(null);
  const {serverId} = useSelector((state) => state.serverId);

  useEffect(() => {
    if (!id) return;

    dispatch(setServerId(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (!serverId) return;

    dispatch(getMe());
    dispatch(getOverview());
    dispatch(getSettings());
    dispatch(getOverviewInfo());
    dispatch(getAllLogs());
    dispatch(getAntiWebHook());
    dispatch(getAntiWebHookLogs());
    dispatch(getAntiSpam());
    dispatch(getAntiSpamAdvanced());
    dispatch(getAntiSpamLogs());
    dispatch(getVerification());
    dispatch(getVerificationAdvanced());
    dispatch(getVerificationRules());
    dispatch(getVerificationMessage());
    dispatch(getVerificationLogs());
    dispatch(getAntiNuke());
    dispatch(getAntiNukeAdvanced());
    dispatch(getAntiNukeLogs());
    dispatch(getDetection());
    dispatch(getDetectionAdvanced());
    dispatch(getDetectionLogs());
    dispatch(getAntiRaid());
    dispatch(getAntiRaidAdvanced());
    dispatch(getAntiRaidLogs());
    dispatch(getMembers());
    dispatch(getRoles());
    dispatch(getChannels());
  }, [dispatch, serverId]);

  useEffect(() => {
    const server = servers.find((s) => s.id === id);
    setSelectedServer(server);
  }, [id]);

  return {selectedServer};
};
